<template>
    <div class="website">
        <div class="backbox">
            <img style="width:100%;height:420px" src="https://www.jpito.com/resource/yituo/common/bg.png" alt="" srcset="">
        </div>
        <div class="picbox" style="display:flex;flex-wrap: wrap;align-items:center">
            <div  v-for="(item,index) in bjData" :key="index" style="position:relative;">
              
                    <div v-if="item.name!='首页'"  class="img" style="position: absolute;filter: brightness(0.5);" :style="{ 'background-image':'url('+baseurl+item.background+')',}"></div>
                    <div v-if="item.name!='首页'" @click="open(item)" class="img" style="position: relative;z-index: 2;">
                        <span style="text-align:center;filter: brightness(1);">
                            <img style="width: 64px;height: 64px; margin-bottom:16px;" :src='baseurl+item.icon' alt="" srcset="">
                            <div class="wenzi">{{item.name}}</div>
                        </span>
                    </div>
            </div>
        </div>
        <!-- 登录 -->
        <el-dialog
            title="登录"
            style="margin-top: 20vh;"
            :visible.sync="logindialog"
            class="dialog_box"
            width="25%">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="邮箱" prop="name" :required="true">
                    <el-input style="width: 300px;" v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="pw">
                    <el-input style="width: 300px;" v-model="ruleForm.pw" show-password></el-input>
                </el-form-item>
            </el-form>
            <div class="register_box">
                <el-button type="text" class="register_box_forget" @click="()=>{forgetdialog=true}">忘记密码?</el-button>
                <el-button type="text" @click="()=>{registerdialog=true}">注册账号</el-button>

            </div>
             <el-button class="dialog_box_login" type="primary" @click="login('ruleForm')">登录</el-button>
        </el-dialog>
         <!-- 请登录 -->
         <el-dialog
            title="请登录"
            style="margin-top: 20vh;"
            :visible.sync="notlogindialog"
            class="notlogin_box"
            width="25%">
           <div class="prompt_box">
                <img class="img_box" src="../../assets/icons/warning.png" alt="">
                <div class="text_box">需要登录会员，才可查看内容</div>
           </div>
           <div class="notlogin_button_box">
                <el-button class="notlogin_button_box_login" @click="()=>{logindialog=true}">立即登录</el-button>
                <el-button class="notlogin_button_box_suer" @click="()=>{notlogindialog=false}">确定</el-button>
           </div>
        </el-dialog>
        <!-- 注册账号 -->
        <el-dialog
            title="注册账号"
            style="margin-top: 20vh;"
            :visible.sync="registerdialog"
            width="25%">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
                <el-form-item label="邮箱" prop="remail" :required="true">
                    <el-input style="width: 300px;" v-model="ruleForm.remail"></el-input>
                </el-form-item>
                <el-form-item label="用户昵称" prop="rname" :required="true">
                    <el-input style="width: 300px;" v-model="ruleForm.rname"></el-input>
                </el-form-item>
                <el-form-item label="输入密码" prop="rpw">
                    <el-input style="width: 300px;" v-model="ruleForm.rpw" show-password></el-input>
                </el-form-item>
                <el-form-item label="再次输入密码" prop="ragainpw" :required="true">
                    <el-input style="width: 300px;" v-model="ruleForm.ragainpw" show-password></el-input>
                </el-form-item>
            </el-form>
            <el-button class="register_suer_box" @click="register('ruleForm')">提交并注册</el-button>
        </el-dialog>
         <!-- 忘记密码 -->
         <el-dialog
            title="忘记密码"
            style="margin-top: 20vh;"
            :visible.sync="forgetdialog"
            class="forget_box"
            width="25%">
            <div class="forget_title_top">
                <img class="forget_title_top_img" src="../../assets/icons/warning.png" alt="">
                <div class="forget_title_top_content">请用注册的邮箱向 service@jpito.com发送邮件，邮件内容为：</div>
            </div>
            <div class="forget_title_bottom">
                忘记密码，申请系统重置密码。
            </div>
            <div class="forget_bottom_box">
                <el-button class="forget_bottom" @click="()=>{forgetdialog=false}">知道了</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import baseurl from '../../utils/video'
    export default{
        data(){
            var validatePass = (rule, value, callback) => {
                const regEmail = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
                if (regEmail.test(value)==false) {
                    callback(new Error('请输入正确的邮箱地址'));
                }else{
                    if(this.ruleForm.name !== '') {
                        this.$refs.ruleForm.validateField('checkPass');
                    }
                    callback();
                }
            };
            var emailvalidate = (rule, value, callback) => {
                const regEmail = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
                if (regEmail.test(value)==false) {
                    callback(new Error('请输入正确的邮箱地址'));
                }else{
                    if(this.ruleForm.remail !== '') {
                        this.$refs.ruleForm.validateField('checkPass');
                    }
                    callback();
                }
            };
            return{
                baseurl,
                notlogindialog:false,
                registerdialog:false,
                logindialog:false,
                forgetdialog:false,
                ruleForm: {
                    name: '123@qq.com',
                    pw: '123456',
                    remail:'',
                    rname:'',
                    rpw:'',
                    ragainpw:'',

                },
                rules: {
                    name: [{ validator: validatePass, trigger: 'blur' }],
                    pw: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                    remail:[ { validator: emailvalidate, trigger: 'blur' }],
                    rname:[{ required: true, message: '请输入昵称', trigger: 'blur' }],
                    rpw:[{ required: true, message: '请输入密码', trigger: 'blur' }],
                    ragainpw:[{ required: true, message: '请再次输入密码', trigger: 'blur' }],
                },
                bjData:[],
            }
        },
        created(){
            this.homemodule()
            this.$webhttp.post(`/hits/module?id=${0}`).then((res)=>{})

        },
        methods:{
            homemodule(){
                this.$webhttp.get('/module').then((res)=>{
                    // console.log(1515,res);
                    if(res.code==200){
                        this.bjData=res.data
                    }
                })
            },
            //登录
            login(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        console.log(111,valid);
                       
                        let obj={
                            "email": this.ruleForm.name,
                            "password": this.ruleForm.pw,
                        }
                        this.$webhttp.post('/member/login',obj).then((res)=>{
                            if(res.code==200){
                                this.$message({
                                    message:'登录成功',
                                    type:'success'
                                })
                                // this.user=res.data.member
                                sessionStorage.setItem('web_token',res.data.token)
                                sessionStorage.setItem('web_user',JSON.stringify( res.data.member))
                                this.logindialog=false;
                                this.notlogindialog=false;
                                
                                this.$store.commit('islogin',true)
                                this.$store.commit('user',res.data.member)
                            }else{
                                this.$message({
                                    message:res.message,
                                    type:"error"
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                    });
            },
            //注册账号
            register(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let issuer=false;
                        if(this.ruleForm.rpw!=this.ruleForm.ragainpw){
                            this.$message({
                                message:'两次密码不一致',
                                type:'error'
                            })
                        }else{
                            issuer=true
                        }
                        if(issuer==true){
                            let obj={
                                "email": this.ruleForm.remail,
                                "nickname": this.ruleForm.rname,
                                "password": this.ruleForm.rpw,
                            }
                            this.$webhttp.post('/member',obj).then((res)=>{
                                if(res.code==200){
                                    this.$message({
                                        message:'注册成功,请登录',
                                        type:'success'
                                    })
                                    this.registerdialog=false
                                }else{
                                    this.$message({
                                        message:res.message,
                                        type:"error"
                                    })
                                }
                            })
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                    });
            },
            open(item) {
               if(item.isExternal==1){
                    this.$webhttp.post(`/hits/module?id=${item.id}`).then((res)=>{})
                    console.log(111);
                    let a=document.createElement('a');
                    a.href=item.externalUrl
                    a.target='_blank'
                    a.click()
               }else{
                   if(sessionStorage.getItem('web_user')==null){
                       // console.log('未登录');
                       this.notlogindialog=true;
                    }else{
                        this.$webhttp.post(`/hits/module?id=${item.id}`).then((res)=>{
                            
                        })
                        this.$router.push({
                            path:'/details',
                            query:{
                                type:item.id
                            }
                        })
                    }
                
               }
            }
        }
    }
</script>
<style lang="less" scoped>
.forget_box{
    /deep/.el-dialog__body{
        padding: 10px 10px;
        height: 245px;
    }
    .forget_title_top{
        width: 100%;
        height: 50px;
        margin-top: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        .forget_title_top_img{
            width: 36px;
            height: 36px;
            margin-right: 10px;
        }
        .forget_title_top_content{
            width: 60%;
           
        }
    }
    .forget_title_bottom{
        padding-left: 113px ;
        color: #333333; font-size: 16px;
        font-weight: bold;
    }
    .forget_bottom_box{
        display: flex;
        justify-content:flex-end;
        margin-top: 50px;
        .forget_bottom{
            color: #FFFFFF;  
            background: #0A6EBA;
        }
    }

}
.dialog_box{
   
   
   .register_box{
       box-sizing: border-box;
       display: flex;
       justify-content: space-between;
       width: 63%;

       .register_box_forget{
           color: #666666;
       }
   }
}
/deep/.el-dialog__body{
    position: relative;
    .register_box{
        position: absolute;
        top: 52% !important;
        right: 12%;
    } 
    .dialog_box_login{
        margin-top: 40px;
        width: 340px;
        height: 40px;
        margin-left: 60px;

    }
    .register_suer_box{
        width: 340px;
        height: 40px;
        background: #0A6EBA !important;
        color: #fff !important;
        margin-left: 80px;
    }
}
.notlogin_box{
    /deep/.el-dialog__body{
        padding: 10px 10px;
    }
    .prompt_box{
        width: 100%;
        height: 140px;
        display: flex;
        justify-content: center;
        align-items: center;
        .img_box{
            width: 36px;
            height: 36px;
            margin-right: 10px;
        }
        .text_box{
            color: #666666;
            font-size: 16px;
            font-weight: 400;   
        }
    }
    .notlogin_button_box{
        display: flex;
        justify-content: flex-end;
        .notlogin_button_box_login{
            color: #0A6EBA;
            background: #fff;
            border: 1px solid #0A6EBA;
        }
        .notlogin_button_box_suer{
            color: #FFFFFF;
            background: #0A6EBA;
        }
    }
}
.website{
    .topbox{     
        background-color: #fff;
        height: 80px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .topbox_button{
            background: #0A6EBA;
            width: 68px;
            height: 32px;
            font-size: 14px;
            color: #fff;
            display: flex;
            text-align: center;
            align-items: center;
        }
        .phone{
            font-size: 24px;
            font-family: Source Han Sans CN VF, Source Han Sans CN VF-Medium;
            font-weight: 500;
            text-align: left;
            color: #666666;
            letter-spacing: 0.96px;
        } 
        .user_box{
           
            .dropdown_box{ 
                display: flex;
                align-items: center;
                .img{
                    width: 30px;
                    height: 30px;
                    box-sizing: border-box;
                    margin-right: 10px;
                }
                .user_name{
                    color:#b2aaaa;
                }
            }
            
        }
    }
    .backbox{
        background-color: antiquewhite;
        height: 420px;
        margin-bottom: 24px;
       
    }
    .picbox{
        // margin:0 272px;
        width: 1408px;
        margin: 0 auto;
        margin-bottom: 20px;
        text-align: center;
        .img{
            width: 320px;
            height: 220px;
            border-radius: 8px;
            margin-right:30px;
            margin-bottom:21px;
            background-size: 100%;
            background-position: center center;
            background-image:rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            .wenzi{
                height: 24px;
                font-size: 24px;
                font-family: Source Han Sans CN VF, Source Han Sans CN VF-Medium;
                font-weight: 500;
                text-align: center;
                color: #ffffff;
                letter-spacing: 0.96px;
            }
        }
        .img:hover{
            // width: 321px;
            // height: 221px;
        }
    }
    a{
        text-decoration: none;
    }
    .messbox{
            width: 300px;
            height: 80px;
            background: #000;
            text-align: center;
            position: fixed;
            left: 42%;
            top: 30%;
            border-radius: 10px;
            animation:mymove 5s infinite;
            /*Safari 和 Chrome:*/
            -webkit-animation:mymove 5s infinite;
            -webkit-animation-iteration-count: 1;
            // animation-fill-mode: forwards;
                .wenzi{
                    color: #fff;
                    font-size: 24px;
                    line-height: 80px;
                }
    }
    @keyframes mymove
    {
        from {opacity: 1;}
        to {opacity: 0;}
    }
    /*Safari 和 Chrome:*/
    @-webkit-keyframes mymove
    {
        from {opacity: 1;}
        to {opacity: 0;}
    }

}</style>